/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener("DOMContentLoaded", function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  let endTimeG;

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();
    if (leftTime < 0) {
      setupNewCountdown();
      leftTime = 0;
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9);
    const currentTime = new Date();
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
  }
  let intervalId;

  function getCutDownTime() {
    setupNewCountdown();
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime();
      $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
      $(".sp_top_cut_down .sp_left_view .sp_minute").html(
        cutDownTimeText.minute
      );
      $(".sp_top_cut_down .sp_left_view .sp_second").html(
        cutDownTimeText.second
      );
    }, 1000);
  }

  getCutDownTime();

  let spImgList = [
    "https://cdn.shopify.com/s/files/1/0883/6867/7161/files/20250821-p1.png",
    "https://cdn.shopify.com/s/files/1/0883/6867/7161/files/20250821-p2.png",

    "https://cdn.shopify.com/s/files/1/0883/6867/7161/files/20250821-b1.png",
    "https://cdn.shopify.com/s/files/1/0883/6867/7161/files/20250821-b2.png",
    "https://cdn.shopify.com/s/files/1/0883/6867/7161/files/20250821-b3.png",
  ];

  new Swiper(".sp-swiper1", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    loop: true,
  });

  jQuery(".sp-scroll").slide({
    mainCell: ".nav-imgs",
    autoPlay: true,
    effect: "leftMarquee",
    interTime: 12,
    vis: 1,
    scroll: 1,
  });
  jQuery(".sp-scroll2").slide({
    mainCell: ".nav-imgs",
    autoPlay: true,
    effect: "leftMarquee",
    interTime: 12,
    vis: 1,
    scroll: 1,
  });

  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");
      let scale = document.body.clientWidth / 1080;
      $("#root").css("zoom", scale);

      window.addEventListener(
        "resize",
        (function () {
          var timer;
          return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              $("#root").css("zoom", "normal");
              let scale = document.body.clientWidth / 1080;
              $("#root").css("zoom", scale);
            }, 100);
          };
        })()
      );
    });

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
      const config = {
        rootMargin: "0px 0px 1300px 0px",
        threshold: 0,
      };

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target;
            const dataSrc = image.getAttribute("data-src");
            image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image); // 停止观察该图片
          }
        });
      },
      config);

      images.forEach(function (image) {
        lazyLoadObserver.observe(image); // 开始观察每个图片
      });
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        });
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      }
    }

    lazyLoadImages();

    preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        let _topHeight =
          $(".time-part").height() + $(".sp-header-top").height() - 10;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            _topHeight * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log("Android");
    } else if (isIOS) {
      console.log("iOS");
    } else if (isPC) {
      console.log("PC");
    } else {
      $(".sp_system").css("letter-spacing", "-4px");
    }
  }

  mainRender();

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName("gradually");
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span");
    const paragraph = gradually.querySelector(".sp-sub-title");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`;
              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3;
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`;
              paragraph.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observer.observe(gradually);
  }

  // 弹幕效果
  const dmRows = document.querySelectorAll(".sp-dm-row");

  dmRows.forEach((row) => {
    // 计算每行的总宽度
    let totalWidth = 0;
    row.childNodes.forEach((child) => {
      if (child.nodeType === Node.ELEMENT_NODE) {
        totalWidth +=
          child.offsetWidth +
          parseInt(window.getComputedStyle(child).marginRight, 10);
      }
    });

    // 设置动态动画持续时间以保持匀速移动
    const speed = 120; // 可以调整速度，数值越大，速度越慢
    const duration = totalWidth / speed;
    row.style.animationDuration = `${duration}s`;
    row.style.transition = `all ${duration}s`;

    row.addEventListener("animationiteration", () => {
      setTimeout(() => {
        row.style.transform = "translateX(0)";
      }, duration);
    });
  });

  const spul = document.getElementById("spul");

  const splis = spul.querySelectorAll(".sp-li");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // 给每个 span 和 i 动画
          splis.forEach((span, index) => {
            const sp1 = span.querySelector(".sp-circle");
            const sp2 = span.querySelector(".sp-tick");
            const sp3 = span.querySelector(".sp-p");

            if (sp1) {
              sp1.style.animation = `sp-circle 1s ease-in-out forwards`;
              sp1.style.animationDelay = `${index * 1}s`;
            }
            if (sp2) {
              sp2.style.animation = `sp-tick 0.8s ease-out forwards 0.95s`;
              sp2.style.animationDelay = `${index * 1 + 0.95}s`;
            }
            if (sp3) {
              sp3.style.animation = `sp-title-ani 0.6s ease-in-out forwards 1.2s`;
              sp3.style.animationDelay = `${index * 1 + 1.2}s`;
            }
          });

          observer.unobserve(spul);
        }
      });
    },
    {
      threshold: 0.3,
    }
  );
  observer.observe(spul);

  const spul2 = document.getElementById("sp-fade-box");
  const splis2 = spul2.querySelectorAll(".sp-ani");

  const observer2 = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // 给每个 span 和 i 动画
          splis2.forEach((span, index) => {
            span.style.animation = `sp-fade-in 1.6s  ease-in-out forwards`;
            span.style.animationDelay = `${index * 0.8}s`;
          });

          observer2.unobserve(spul2);
        }
      });
    },
    {
      threshold: 0.3,
    }
  );
  observer2.observe(spul2);

  const spul3 = document.getElementById("sp-fade-box2");
  const splis3 = spul3.querySelectorAll(".sp-ani");

  const observer3 = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // 给每个 span 和 i 动画
          splis3.forEach((span, index) => {
            span.style.animation = `sp-fade-in 1.5s  ease-in-out forwards `;
            span.style.animationDelay = `${index * 0.8}s`;
          });

          observer3.unobserve(spul3);
        }
      });
    },
    {
      threshold: 0.3,
    }
  );
  observer3.observe(spul3);

  const spul4 = document.getElementById("sp-fade-box3");
  const splis4 = spul4.querySelectorAll(".sp-ani");

  const observer4 = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // 给每个 span 和 i 动画
          splis4.forEach((span, index) => {
            span.style.animation = `sp-fade-in 1.5s  ease-in-out forwards `;
            span.style.animationDelay = `${index * 0.8}s`;
          });

          observer4.unobserve(spul4);
        }
      });
    },
    {
      threshold: 0.3,
    }
  );
  observer4.observe(spul4);

  const spul5 = document.getElementById("sp-fade-box4");
  const splis5 = spul5.querySelectorAll(".sp-ani");

  const observer5 = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // 给每个 span 和 i 动画
          splis5.forEach((span, index) => {
            span.style.animation = `sp-fade-in 1.5s  ease-in-out forwards `;
            span.style.animationDelay = `${index * 0.8}s`;
          });

          observer5.unobserve(spul5);
        }
      });
    },
    {
      threshold: 0.3,
    }
  );
  observer5.observe(spul5);
  let prods = window.product
    let price = prods[0].price / 100
    let comprice = prods[0].compare_at_price / 100
    $('.reduce').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) - 1
      if (num > 0) {
        input.value = num
        $(this).closest('.product-box').find('.sp-price1 span').html((price * num).toFixed(2) + '')
        $(this).closest('.product-box').find('.sp-price2 span').html((comprice * num).toFixed(2) + '')
      }
    })
    $('.add').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) + 1
      input.value = num
      $(this).closest('.product-box').find('.sp-price1 span').html((price * num).toFixed(2) + '')
        $(this).closest('.product-box').find('.sp-price2 span').html((comprice * num).toFixed(2) + '')
    })

  $(".product-box .sp-opt").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    let _index = $(this).attr('data-index');
    let parentIndex = $(this).closest('.product-box').index()
    let price = (prods[_index].price / 100).toFixed(2)
    let compare = (prods[_index].compare_at_price / 100).toFixed(2)
    if(parentIndex == 1){
        let perPrice = (price / 3).toFixed(2)
        $(this).closest('.product-box').find('.sp-price3 span').html(perPrice)
    }
    
    $(this).closest('.product-box').find('.price-group .sp-price1 span').html(price)
    $(this).closest('.product-box').find('.price-group .sp-price2 span').html(compare)
    // let _index = $(this).index();

    // $(this)
    //   .parents(".product-box")
    //   .find(".sp-p-img")
    //   .eq([_index])
    //   .show()
    //   .siblings(".sp-p-img")
    //   .hide();
  });

  $('.sp-btn-style').on('click',function(){
    let num = $(this).siblings('.addGroup').find('input').val()
    num == undefined ? (num = 1) : ''
    let id = $(this).attr('data-id')
    window.location.href = '/cart/' + id + ':' + num
  })
  // 弹窗 start
  //  var main_id = "";
  //  var num = 1
  //   $('.emitCheckout').click(function(){
  //     num = $(this).siblings('.addGroup').find('input').val()
  //     num == undefined ? (num = 1) : ''
  //     main_id = $(this).closest('.product-box').find('.sp-opts .active').data('id');
  //     // main_id = $(this).siblings('.select_span').find('span.on').data('id')
  //     // window.location.href = "/cart/" + id + ":1"
  //   })

  // function getPopProdId(){
  //   let selectVals = [];
  //  $('.overbuy_wrap .sp-subopt.active').each(function(){
  //     selectVals.push($(this).data('val'))
  //   })

  //   let cur = popProduct.filter(item => {
  //     let option1 = selectVals[0];
  //     let option2 = null;
  //     let option3 = null;
  //     if(selectVals[1]){
  //       option2 = selectVals[1];
  //     }
  //     if(selectVals[2]){
  //       option3 = selectVals[2];
  //     }

      
  //     return item.option1 == option1 && item.option2 == option2 && item.option3 == option3
  //   })

 
    
  //   return cur[0];
  // }

  // $('.overbuy-select div').click(function(){
  //    $(this).siblings().removeClass('active')
  //    $(this).addClass('active')
  //   let cur = getPopProdId();
    
  //   if(cur){
  //     $(".main-btn").text('GET 10% oFF').removeClass("overbuy_disabled")
  //     let _price = parseFloat(cur.price / 100).toFixed(2);
  //     let _compare_at_price = parseFloat(cur.compare_at_price / 100).toFixed(2);
  
  //     $('.overbuy_price span').eq(0).html('$' + _price);
  //     $('.overbuy_price span').eq(1).html('$' + _compare_at_price);
  //   }else{
  //     $(".main-btn").text("Unavailable").addClass("overbuy_disabled")
  //   }
    
  // })

  


  // window.emitSubmit = function(_type){
  //    if(_type == 'all'){
  //     // var bundle_sku = data[$('input[name="overbuy1"]:checked').val()][$('input[name="overbuy2"]:checked').val()]
  //     let _id = getPopProdId()?.id;
  //      if(!_id) return
  //     console.log(_id)
       
  //     window.location.href = `/cart/${main_id}:${num},${_id}:1`
  //   }else{
  //     window.location.href = `/cart/${main_id}:${num}`
  //   }
  // }



  // 弹窗 end
  //  $('.sp-btn-style').on('click',function(){
  //   let num = $(this).siblings('.addGroup').find('input').val()
  //   num == undefined ? (num = 1) : ''
  //   let id = $(this).closest('.product-box').find('.sp-opts .active').data('id');
  //   var cart =
  //   document.querySelector('cart-notification') ||
  //   document.querySelector('cart-drawer')
  //   let data = {
  //     id: id,
  //     quantity: parseInt(num),
  //   }
  //   if (cart) {
  //     data['sections'] = cart.getSectionsToRender().map(section => section.id)
  //   }
  //   $.ajax({
  //     type: 'POST',
  //     url: '/cart/add.js',
  //     data: data,
  //     success: function (res) {
  //       if (!cart) {
  //         window.location = window.routes.cart_url
  //         // that.closePop();
  //       } else {
  //         cart.renderContents(res)
  //         if (cart && cart.classList.contains('is-empty'))
  //           cart.classList.remove('is-empty')
  //       }
  //     },
  //     dataType: 'json',
  //   })

  // })
});
